import { api } from '~shared/api/origin';

import type { GetPromoEventsApiResponse } from './types';

export const { useGetPromoEventsQuery } = api.injectEndpoints({
	endpoints: (build) => ({
		getPromoEvents: build.query<GetPromoEventsApiResponse, { userId: string }>({
			query: ({ userId }) => ({
				url: `/ai/liveops/${userId}/event/active`,
				method: 'GET',
			}),
		}),
	}),
});
